import React from 'react';
const TLServiceComponent = React.createContext(null);
export default TLServiceComponent;
